import { Button } from '@/components/ui/Button/Button';
import { DialogBody, DialogFooter } from '@/components/ui/Dialog/Dialog';
import { Illustration } from '@/components/ui/Illustration/Illustration';
import { useCancelAppointment } from '@/features/scheduling/api/cancelAppointment';
import { invalidateSchedulingQueries } from '@/features/scheduling/utils/invalidateSchedulingQueries';
import { captureAnalyticsEvent } from '@/lib/mixpanel';
import { Trans, useTranslation } from 'react-i18next';
import { useCancelFlow } from '../../context/useCancelFlow';

export const LateCancelErrorStep = () => {
  const { t } = useTranslation('scheduling', { keyPrefix: 'cancelDialog.steps.lateCancelErrorStep' });

  const { data, closeCancelDialog, goToStep } = useCancelFlow();

  const { mutate: cancelAppointment, isPending } = useCancelAppointment({
    options: {
      onSuccess: () => {
        void captureAnalyticsEvent('cancelling_late_complete', {
          appointment_id: data.appointment?.appointment_id,
          apply_to_following: data.applyToFollowingSessions,
        });
        invalidateSchedulingQueries();
        goToStep('success');
      },
      onError: () => {
        goToStep('error');
      },
    },
  });

  const handleKeepSession = () => {
    void captureAnalyticsEvent('cancelling_late_closed', {
      appointment_id: data.appointment?.appointment_id,
    });
    closeCancelDialog();
  };

  const handleSubmit = () => {
    cancelAppointment({
      appointmentId: data.appointment!.appointment_id,
      studentId: data.appointment!.student_id,
      applyToFollowingAppointments: data.applyToFollowingSessions,
      isLateCancel: true,
    });
  };

  return (
    <>
      <DialogBody className='flex h-full flex-col items-center justify-center text-center'>
        <Illustration name='problem' className='size-28' />
        <div className='max-w-[320px]'>
          <p className='text-heading-m-semibold mb-4'>{t('title')}</p>
          <p>{data.applyToFollowingSessions ? <Trans t={t} i18nKey='recurringSessionDescription' /> : t('singleSessionDescription')}</p>
        </div>
      </DialogBody>
      <DialogFooter>
        <Button variant='text-secondary' className='w-full' onClick={handleKeepSession}>
          {t('backButton.label')}
        </Button>
        <Button className='w-full' onClick={handleSubmit} isLoading={isPending} disabled={isPending}>
          {t('confirmButton.label')}
        </Button>
      </DialogFooter>
    </>
  );
};
